import { PaginatedDataSheetLogisticsEstimates } from '@lune-fe/dapi-models'
import { TableNew } from '@lune-fe/lune-ui-lib'
import { Dispatch, RefObject, SetStateAction } from 'react'

import { PaginatedDataSheetEmpty } from 'endpoints/dapi'
import { SelectableDataSheetLogisticsRow } from 'views/CalculateEmissions/index'

const SelectableDataSheetLogisticsTable = ({
    paginatedEstimates,
    currentPage,
    pageHistoryRef,
    queryParams,
    loading,
    selectedIds,
    setSelectedIds,
}: {
    paginatedEstimates?: PaginatedDataSheetLogisticsEstimates | PaginatedDataSheetEmpty
    currentPage: number
    pageHistoryRef: RefObject<(string | undefined)[]>
    queryParams: string | undefined
    loading: boolean
    selectedIds: Set<string>
    setSelectedIds: Dispatch<SetStateAction<Set<string>>>
}) => {
    const allIds = paginatedEstimates?.data?.map((item) => item.id) || []
    const allSelected = selectedIds.size === allIds.length && allIds.length > 0
    const someSelected = selectedIds.size > 0 && selectedIds.size < allIds.length

    const handleSelectAll = (checked: boolean) => {
        if (checked) {
            setSelectedIds(new Set(allIds))
        } else {
            setSelectedIds(new Set())
        }
    }

    return (
        <TableNew.TableContainer>
            <TableNew
                sx={{ minWidth: paginatedEstimates?.data?.length ? '900px' : 'auto' }}
                stickyHeader
                loading={!paginatedEstimates || loading}
                empty={!loading && !paginatedEstimates?.data?.length}
                headerCells={
                    <>
                        <TableNew.TableCell
                            colSpan={12}
                            colSize={12}
                            sx={{ pl: `0 !important`, pr: `0 !important` }}
                        >
                            <TableNew.TableContainer>
                                <TableNew
                                    withSelectCheckbox={true}
                                    sx={{
                                        tableLayout: 'fixed',
                                    }}
                                    headerCells={
                                        <TableNew.TableRow>
                                            <TableNew.TableCheckboxCell
                                                checked={allSelected}
                                                indeterminate={someSelected}
                                                onCheckedChange={handleSelectAll}
                                                showOnHover={true}
                                            />
                                            <TableNew.TableCell colSize={2}>
                                                Origin
                                            </TableNew.TableCell>
                                            <TableNew.TableCell colSize={2}>
                                                Destination
                                            </TableNew.TableCell>
                                            <TableNew.TableCell colSize={2}>
                                                Status
                                            </TableNew.TableCell>
                                            <TableNew.TableCell colSize={2}>
                                                Date
                                            </TableNew.TableCell>
                                            <TableNew.TableCell colSize={2} alignEnd>
                                                Legs
                                            </TableNew.TableCell>
                                            <TableNew.TableCell colSize={1} alignEnd>
                                                tCO₂e
                                            </TableNew.TableCell>
                                            <TableNew.TableCell colSize={1} alignEnd />
                                        </TableNew.TableRow>
                                    }
                                />
                            </TableNew.TableContainer>
                        </TableNew.TableCell>
                    </>
                }
                bodyCells={
                    <>
                        {paginatedEstimates?.data?.map((calculation, i: number) => {
                            const isSelected = selectedIds.has(calculation.id)
                            return (
                                <SelectableDataSheetLogisticsRow
                                    key={i}
                                    calculation={calculation}
                                    currentPage={currentPage}
                                    pageHistoryRef={pageHistoryRef}
                                    queryParams={queryParams}
                                    isSelected={isSelected}
                                    onSelectChange={(checked) => {
                                        setSelectedIds((prev) => {
                                            const newSet = new Set(prev)
                                            if (checked) {
                                                newSet.add(calculation.id)
                                            } else {
                                                newSet.delete(calculation.id)
                                            }
                                            return newSet
                                        })
                                    }}
                                />
                            )
                        })}
                    </>
                }
            />
        </TableNew.TableContainer>
    )
}

export default SelectableDataSheetLogisticsTable
